import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

import SectionPaper from './section_paper'

const useStyles = makeStyles((theme) => ({
  root: { padding: 20 },
}))

const Index = (props) => {
  const { maxWidth } = props
  const classes = useStyles()

  return (
    <Container maxWidth={maxWidth ? maxWidth : 'md'}>
      <Grid
        container
        spacing={1}
        // justify="center"
        // alignItems="center"
        className={classes.root}
      >
        <Grid item xs={12}>
          {props.children}
        </Grid>
      </Grid>
    </Container>
  )
}

export default Index
